import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "caret-d",
  "use": "caret-d-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"caret-d\"><defs><style>#caret-d .cls-1{fill:none}</style></defs><title>资源 76</title><g id=\"caret-d_图层_2\" data-name=\"图层 2\"><g id=\"caret-d_图层_1-2\" data-name=\"图层 1\"><path id=\"caret-d_Rectangle_37_Copy_14\" data-name=\"Rectangle 37 Copy 14\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"caret-d_caretdown\"><path id=\"caret-d_Shape\" d=\"M1.75 8.5l9.47 9.94a1.1 1.1 0 0 0 1.49 0l9.52-9.94c.58-.55.12-1.44-.74-1.44h-19c-.86 0-1.32.94-.74 1.44z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/caret-d.svg
// module id = nuwo
// module chunks = 6